import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Scarcities } from '@sorare/core/src/atoms/icons/Scarcities';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { ANY_SPORT_MISSIONS_CATEGORY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import {
  formatScarcity,
  playableBlockchainRarities,
} from '@sorare/core/src/lib/cards';
import { gridBackground } from '@sorare/core/src/lib/style';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(FullWidthContainer.NoPadding)`
  background: ${gridBackground({ gridColor: 'var(--c-nd-50)' })};
  min-height: calc(100vh - var(--parent-stack-height));
`;
const Wrapper = styled.div`
  width: 100%;
  @media ${tabletAndAbove} {
    width: 350px;
  }
`;

type Props = {
  rarity: string;
  category: string;
};
export const MissionsPageLayout = ({ rarity, category }: Props) => {
  const navigate = useNavigate();
  const { sport, generateSportContextPath } = useSportContext();
  const { lifecycle, update } = useLifecycle();

  return (
    <Root>
      <Wrapper>
        <TextSwitch
          value={rarity}
          compact
          onChange={(R: string) => {
            update(LIFECYCLE.missionsRarityFilter, {
              ...(lifecycle?.missionsRarityFilter || {}),
              [sport]: R,
            });
            navigate(
              generateSportContextPath(ANY_SPORT_MISSIONS_CATEGORY_RARITY, {
                params: {
                  category,
                  rarity: R,
                },
              })
            );
          }}
          options={[Rarity.common, ...playableBlockchainRarities].map(R => ({
            value: R,
            label: (
              <Horizontal>
                <Scarcities rarities={[R]} />
                {R === rarity && formatScarcity(R)}
              </Horizontal>
            ),
          }))}
        />
      </Wrapper>
      <Outlet />
    </Root>
  );
};
